export const PermitsList = {


  //acciones

  //inventario
  SAM_INVENTORY_EDIT: 2,
  SAM_INVENTORY_WL_ADD: 1,
  SAM_INVENTORY_WL_REMOVE: 8,
  SAM_INVENTORY_EXPORT: 16,
  SAM_INVENTORY_INACTIVATE: 32,
  SAM_INVENTORY_ACTIVATE: 64,
  SAM_PARAMS: 1073741824,//cambiar valor

  //cambiar valor
  SAM_COUNTERS: 536870912, //cambiar valor

  //usuarios
  SEC_USERS_ADD: 8192,
  SEC_USERS_EDIT: 16384,
  SEC_USERS_DELETE: 2147483648,

  //catalogo
  CATALOGS_ADD: 32768,
  CATALOGS_DELETE: 65536,
  CATALOGS_EDIT: 131072,
  CATALOGS_IMPORT: 262144,
  CATALOGS_EXPORT: 524288,

  //reasignacion
  OP_REASSIGN_SAM: 67108864,
  //sandbox
  SANDBOX_EXPORT: 4294967296


};


export const AccessListValues = {
  SAM_INVENTORY_LIST: 1,//acceso
  SEC_ROLE_LIST: 8,//acceso
  CATALOGS_LIST: 16,//acceso
  SEC_USERS_LIST: 4, //acceso
  OP_REASSIGN_SAM_LIST: 64,//acceso
  HISTORY_GENERAL: 1024,//acceso
  SANDBOX_LIST: 52,// acceso
  HISTORY_USERS: 128,// acceso
}
//permissionValue = accesos o menus (header)
// actionValue = botones de accion
export const PermitWebList: number[] = [
  AccessListValues.SAM_INVENTORY_LIST, //SAM_INVENTORY_LIST
  AccessListValues.SEC_ROLE_LIST, //SEC_ROLE_LIST
  AccessListValues.CATALOGS_LIST, //CATALOGS_LIST
  AccessListValues.SEC_USERS_LIST, //SEC_USERS_LIST
  AccessListValues.OP_REASSIGN_SAM_LIST, //SAM_REASIGNMENT_LIST
  AccessListValues.HISTORY_GENERAL,
  AccessListValues.CATALOGS_LIST,
  AccessListValues.HISTORY_USERS
];
